import type { FaireProductEntity } from "../../entity_types/product";

export const p_f2azmzajvx: FaireProductEntity = {
  token: "p_f2azmzajvx",
  type: "product",
  name: "Raffia Kids Bag with Circus Theme",
  brandToken: "b_c8yganb0qb",
  brandName: "",
  imageUrl:
    "https://cdn.faire.com/fastly/c1f843e5234c73fd7229ea484d3998a5f3f75730624f35d8bd78dce2f806d59f.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2a8b29285f7e5191edf249c434e3ed76a958004fb79b1f7020485e2909aafe33.png",
    "https://cdn.faire.com/fastly/5cf7b856e6abb64437588a8966b66b337f4b4dffd2c15b8614470e06fa7592f9.png",
    "https://cdn.faire.com/fastly/95a42a7f7509933e5894b08ef67b89563c60c6a40fcb6f35f9a0abfb3014c033.png",
  ],
  priceDollars: 34.49,
  description:
    "\nCan’t get enough of our raffia houses? Good news, we made matching bags for the little ones! Like our houses the bags are also made of the natural and sustainable material raffia. This one is with a circus theme – completed with a convenient handle on top of the lid. Perfect for your little ones to carry all their treasures, making every day a little more magical.\n\nThis product is handmade in the amazing natural material, raffia. Raffia fibers come from palm fronds and all RICE raffia products come from Madagascar, which also is the place where the history of RICE began. Our raffia baskets and raffia houses were some of our very first products.",
  tags: [],
  msrpDollars: 68.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-07T04:57:37.872Z",
    importedBy: "gen-brand-update-tile-products.mjs",
  },
  categoryTokens: [],
};
